package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteSummary
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/complete — driver-initiated end of route (MIL-36). */
class CompleteRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(id: String, confirmed: Boolean = true): RouteSummary =
        repository.completeRoute(id, confirmed)
}
